import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import useServices from "../../../../hooks/useServices.js";
import DataSelect from "../../../../../ui/DataSelect/index.js";

const defaultData = {
    offerDevelopment: false,
    offerEducation: false,
    offerResources: false,
};

const styles = () => ({
    root: {
      maxWidth: 774,
      minWidth: 400,
        display: "flex",
        flexDirection: "column",
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        },
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#000"
        }
    },
    heading: {
        fontSize: 14,
        display: "flex",
        alignItems: "center",
        color: "#000000",
        margin: "25px 0 15px 0"
    },
    checkbox: {
        "& > .MuiCheckbox-colorPrimary.Mui-checked": {
            color: "rgba(0, 127, 189, 0.7);"
        }
    }
});

const EducationalServices = ({
    disabled,
    onFormChange,
    initialData,
    classes,
    editmode
}) => {
    const [data, setData] = React.useState(initialData || defaultData);

    const { dataSources, getServicesForm } = useServices();

    useEffect(() => {
        getServicesForm();
    }, []);

    const onChange = (field, value) => {
        const newState = {
            ...data,
            [field]: value
        };

        setData(newState);
        onFormChange(newState);
    };

    return (
        <div className={classes.root}>
            <Typography className={classes.heading}>
                Виды услуг для ЦОПП
            </Typography>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={data.offerDevelopment}
                        disabled={disabled || !editmode}
                        onChange={(_, val) => onChange("offerDevelopment", val)}
                        value="checked"
                        color="primary"
                    />
                }
                label="Разработка образовательных программ и цифровых учебных материалов"
                classes={{
                    label: classes.label,
                    root: classes.checkbox
                }}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={data.offerEducation}
                        disabled={disabled || !editmode}
                        onChange={(_, val) => onChange("offerEducation", val)}
                        value="checked"
                        color="primary"
                    />
                }
                label="Проведение обучения"
                classes={{
                    label: classes.label,
                    root: classes.checkbox
                }}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={data.offerResources}
                        disabled={disabled || !editmode}
                        onChange={(_, val) => onChange("offerResources", val)}
                        value="checked"
                        color="primary"
                    />
                }
                label="Предоставление ресурсов"
                classes={{
                    label: classes.label,
                    root: classes.checkbox
                }}
            />
        </div>
    );
};

export default withStyles(styles)(EducationalServices);
